var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whole-page defult-page"},[_c('left-page-navigation'),_c('div',{staticClass:"page-content"},[_c('page-navigation'),_c('div',{staticClass:"wrapp-iterable-content"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }